import {
  Avatar,
  Checkbox,
  FormHelperText,
  Stack,
  Typography,
} from '@mui/material';
import { Checkmark, CheckmarkChecked } from 'Images';
import { UseFormRegisterReturn } from 'react-hook-form';

interface ICheckboxInput {
  name: string;
  label: string;
  register: UseFormRegisterReturn<string>;
  error?: { message: string };
}

export const CheckboxInput = ({
  name,
  label,
  register,
  error,
}: ICheckboxInput) => {
  return (
    <Stack width={'fit-content'}>
      <Stack
        alignItems='center'
        flexDirection='row'
        gap='12px'
        sx={{
          '.MuiSvgIcon-root': {
            fill: error?.message !== undefined ? '#d32f2f' : undefined,
          },
        }}
      >
        <Checkbox
          {...register}
          id={register.name.trim().replace(' ', '-')}
          inputProps={{
            'aria-label': `checkbox-${name}`,
          }}
          edge='start'
          sx={{ p: 0, pl: '8px', alignSelf: 'start' }}
          icon={
            <Avatar src={Checkmark} sx={{ width: '24px', height: '24px' }} />
          }
          checkedIcon={
            <Avatar
              alt={''}
              src={CheckmarkChecked}
              sx={{ width: '24px', height: '24px' }}
            />
          }
        />
        <Typography
          variant={'body3'}
          color={error?.message !== undefined ? '#d32f2f' : undefined}
          id={`checkbox-${name.trim().replace(' ', '-')}`}
          component='label'
          htmlFor={register.name.trim().replace(' ', '-')}
          sx={{ cursor: 'pointer' }}
        >
          {label}
        </Typography>
      </Stack>
      {error?.message !== undefined && (
        <FormHelperText
          id={label.trim().replace(' ', '-')}
          role={'alert'}
          error
          sx={{ m: '0 14px' }}
        >
          {error?.message}
        </FormHelperText>
      )}
    </Stack>
  );
};
